export default __webpack_public_path__ + "static/media/parent.7828d0bd.png";